import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { logoutAdmin } from "../../pages/admin/adminAuth";
import "./AdminLayout.css";

// Every back-office page. Items and routes are the same as before the redesign,
// plus "กองบรรณาธิการ" for the new newspaper submissions.
export const ADMIN_MENU = [
  {
    section: "กองบรรณาธิการ",
    items: [
      { to: "/admin/editor", label: "ประกาศจากลูกค้า" },
      { to: "/admin/articles", label: "ข่าว / ประชาสัมพันธ์" },
    ],
  },
  {
    section: "ประกาศ",
    items: [
      { to: "/admin/announce", label: "ลงประกาศ" },
      { to: "/admin/announcements", label: "รายการประกาศ" },
      { to: "/admin/upload-announcement", label: "อัปโหลดประกาศ" },
      { to: "/admin/excel-to-pdf", label: "นำเข้าจาก Excel" },
    ],
  },
  {
    section: "เอกสาร & PDF",
    items: [
      { to: "/admin/daily-announcements", label: "จัดการประกาศรายวัน" },
      { to: "/admin/daily-pdf", label: "สร้าง PDF รายวัน" },
    ],
  },
  {
    section: "เนื้อหาเว็บ",
    items: [{ to: "/admin/content", label: "แก้ไขเนื้อหาเว็บ" }],
  },
];

function AdminLayout({ title, children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const handleLogout = async () => {
    await logoutAdmin();
    navigate("/admin", { replace: true });
  };

  let n = 0;
  return (
    <main id="main" className="adm-shell container">
      <div className="adm-heading">
        <div>
          <p className="eyebrow">ADMIN CONSOLE · MANEENOPKAO GROUP</p>
          <h2>{title || "หลังบ้าน"}</h2>
        </div>
        <div className="adm-heading-actions">
          <button type="button" className="adm-menu-toggle text-link" onClick={() => setMenuOpen((v) => !v)} aria-expanded={menuOpen}>
            เมนูหลังบ้าน <span>{menuOpen ? "−" : "+"}</span>
          </button>
          <button type="button" className="text-link" onClick={handleLogout}>
            ออกจากระบบ <span>→</span>
          </button>
        </div>
      </div>

      <div className="adm-layout">
        <nav className={`adm-menu${menuOpen ? " open" : ""}`} aria-label="เมนูหลังบ้าน">
          {ADMIN_MENU.map((group) => (
            <div className="adm-menu-group" key={group.section}>
              <p className="eyebrow">{group.section}</p>
              {group.items.map((item) => {
                n += 1;
                return (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === "/admin/announcements"}
                    className={({ isActive }) => `adm-menu-item${isActive ? " active" : ""}`}
                  >
                    <span>{String(n).padStart(2, "0")}</span>
                    <strong>{item.label}</strong>
                    <span className="tab-arrow">→</span>
                  </NavLink>
                );
              })}
            </div>
          ))}
        </nav>

        <section className="adm-content">{children}</section>
      </div>
    </main>
  );
}

export default AdminLayout;
